export class ZipCode {
  area_codes = [];
  branch_name = '';
  branch_zip = '';
  country = '';
  county = '';
  latitude = 0;
  longitude = 0;
  primary_city = '';
  state = '';
  zip = '';

  /**
   * Whether the zip code is valid.
   * @returns {boolean}
   */
  get valid() {
    return this.zip.length === 5;
  }

  /**
   * @param json
   * @returns {ZipCode}
   */
  static fromJSON(json) {
    const instance = new ZipCode();
    Object.assign(instance, json);
    return instance;
  }
}
